import { InfoSupplement, ValidationError } from '@zinnia/form-engine-sdk';

export type FieldProps = MuiFieldProps & CustomFieldProps & OptionInfo;

// Props that should be passed down to the Material UI field component
export type MuiFieldProps = {
  name: string;
  label?: string;
  disabled?: boolean;
};

// Props that should *not* be passed down to the Material UI field component

export type ValidationProps = {
  validationError?: ValidationError;
};

export type CustomFieldProps = ValidationProps & {
  id?: string;
  validationError?: ValidationError;
  value: unknown;
  onAnswerChange: (answer: unknown) => void;
  'data-testid'?: string;
  title?: string;
  subtitle?: string;
  isReadOnly?: boolean;
  optionalText?: string;
};

export type InputVariant = 'standard' | 'outlined';

export type OptionInfo = {
  info?: InfoSupplement;
};

export function getFieldLabel(fieldProps: Pick<FieldProps, 'title' | 'label'>): string {
  return fieldProps.title || fieldProps.label || '';
}

export function formatRequiredFieldTitle(required = false, title = '', label = '', optionalText = ''): string {
  if (required && title !== '') return `* ${title}`;

  const text = title || label || '';
  if (!required && text !== '' && optionalText !== '') return `${text} (${optionalText})`;
  return text;
}
